export const controllerPathToStimulusControllerName = (
  fileName: string,
  basePath: string,
): string =>
  fileName
    .replace(new RegExp(`^${basePath}/`), '')
    .replace(/_controller\..+$/, '')
    .replace(/\//g, '--')
    .replace(/_/g, '-');
